module.exports = __webpack_public_path__ + "img/step4.4af2822c.png";